export default {
      id: "weather__night-mostlyc-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__night-mostlyc",
      toString: function () {
        return this.url;
      }
    }